import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FilesDropzone } from 'components';

import { UploadTrackerFiles } from 'views/SiteTracker/actions/SiteTrackerActions';
import ModalDialog from '../../../../components/ModalDialog/ModalDialog';

const ImportSiteTrackerModal = (props) => {
	const { title, onClose, open, ...rest } = props;
	const dispatch = useDispatch();
	const user = useSelector(state => state.session.user.id);

	const _onConfirmClick = (files) => {
		if (files && files[0]) {
			const file = files[0];
			dispatch(UploadTrackerFiles(file, user));
		}
	};

	return (
		<ModalDialog
			onClose={onClose}
			title={title}
			open={open}
			maxWidth="lg"
			hasConfirm={false}
		>
			<FilesDropzone multiple={false} acceptedTypes=".xlsx" upload={_onConfirmClick} />
		</ModalDialog>
	);
};

ImportSiteTrackerModal.propTypes = {
	title: PropTypes.string,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired
};

export default ImportSiteTrackerModal;
